import React from 'react'
import 'react-phone-number-input/style.css'
import BetaWaitlist from "../Beta-Waitlist/BetaWaitlist";
import './AnimationSection.css';
//import JoinPriorityWaitlistBtn from '../ViralLoops/JoinPriorityWaitlistBtn'
function AnimationSection(props) {


    const onInitialSubmit = () => {
        props.setShowJoinWaitList(true);
    };

   
    const handleRedirect = ()=> {
        window.location.href = '/rentdirect'; 
      }

      const handleShield = ()=> {
        window.location.href = '/rentshield'; 
      }

      const handleId = ()=> {
        window.location.href = '/rentid'; 
      }

      const handleIacademy = ()=> {
        window.location.href = '/rentacademy'; 
      }

      const handlesuccess = ()=> {
        window.location.href = '/rentsuccess'; 
      }

      const handleaii = ()=> {
        window.location.href = '/rentai'; 
      }


    


    return (
        <>
            <section id="third" className="animation_sec">


                <div className="container">
                    <div className="row">
                        <div className="col-12 text-lg-center text-start px-0">
                            <img className="logo11" src="/img/Rentid-white.svg" alt="Rentid Logo" width={117} />
                            <h2>
                                Seamless, effortless, and commissionless rental platform.
                            </h2>
                        </div>
                    </div>
                   
                     <div className="mobielhovernone">
                        <div className="hover-card rent-direct">
                           <div className="rent-overlay"></div>
                            <div className="logo-container" onClick={handleRedirect}>
                                <img alt="Rent Direct logo" className="logo" src="/img/animation/rentidirect.svg" />
                        <p ><span style={{}}>rent</span>direct</p>
                            </div>
                        </div>
                     
                        <div className="hover-card rent-id">
						      <div className="rent-overlay"></div>
                              <div className="logo-container" onClick={handleId}>
                                <img className="logo" src="/img/animation/rent-id-icon.svg" alt="Rent ID logo" />
                          <p><span>rent</span>ID</p>
                            </div>
                        </div>
                       
                        <div className="hover-card rent-shield">
                            <div className="rent-overlay"></div>
                            <div className="logo-container" onClick={handleShield}>
                                <img className="logo" src="/img/animation/rent-shield.svg" alt="Rent Shield" />
                                <p><span>rent</span>shield</p>
                            </div>
                        </div>

                        <div className="hover-card rent-ai">
                            <div className="rent-overlay"></div>
                            <div className="logo-container" onClick={handleaii}>
                                <img className="logo" src="/img/animation/rent_ai_logo_home.svg" alt="Rent AI logo" />
                                <p><span>rent</span>AI</p>
                            </div>
                        </div>

                        <div className="hover-card rent-success">
						     <div className="rent-overlay"></div>
                            <div className="logo-container" onClick={handlesuccess}>
                                <img className="logo" src="/img/animation/rent-success.svg" alt="Rent Success Logo" />
                          <p><span>rent</span>success</p>
                            </div>
                        </div>
                        <div className="hover-card rent-accademy">
						     <div className="rent-overlay"></div>
                            <div className="logo-container" onClick={handleIacademy}>
                                <img className="logo" src="/img/animation/rent-accademy.svg" alt="Rent Academy Logo" />
                          <p><span>rent</span>academy</p>
                            </div>
                        </div>
                    </div> 
            

                    {/* <div className="row d-lg-none d-block pt-4">
                        <div className="col-12 px-3">
                            <img src="/img/rentdirect-animation.svg" id='RentDirect' alt="Rentdirect Animation" className="w-100" onClick={handleClick} />
                        </div>
                        <div className="col-12">
                            <div className="row">
                                <div className="col-6 pb-3 subicons">
                                    <img src="/img/rentacademy-animation.svg" id='RentAcademy' alt="Rentacademy Animation" className="w-100" onClick={handleClick} />
                                </div>
                                <div className="col-6 pb-3 subicons">
                                    <img src="/img/rentsuccess-animation.svg" id='RentSuccess' alt="Rentsuccess Animation" className="w-100" onClick={handleClick} />
                                </div>
                                <div className="col-6 pb-3 subicons">
                                    <img src="/img/rentid-animation.svg" id='Rentid' alt="Rentid Animation" className="w-100" onClick={handleClick} />
                                </div>
                                <div className="col-6 pb-3 subicons">
                                    <img src="/img/rentshield-animation.svg" id='rentshield' alt="Rentshield Animation" className="w-100" onClick={handleClick} />
                                </div>
                            </div>
                        </div>

                    </div> */}

                

              <div className="col-md-12 text-center rental-plateform">
               <p>Our suite of connected products and tools converge to bring you the most advanced all-in-one rental platform.</p>
              </div>

                    <div className="col-md-12 px-1 mb-5 d text-center mt-5">
                        <button type="button" id="join_waits" className="btn btn-dark waitlist_pop" onClick={onInitialSubmit}>Join the Waitlist</button>
                        {/* <JoinPriorityWaitlistBtn id="join_waits" buttonClass='btn btn-dark waitlist_pop' buttonText="Join the Waitlist"/> */}

                        {/* <BetaWaitlist btn={true} btnId="join_waits" buttonClass="btn btn-dark waitlist_pop" buttonText="Join the Waitlist" /> */}
                    </div>

{/* 
                <div id="thirdAnimation" className={`subparts ${isVisible ? 'full-screen' : 'd-none'}`}>
                    <div className="tab-control">
                        <button type="button" className="btn close d-lg-none d-block" onClick={handleCloseButtonClick}>
                            <img src="/img/left-arrow.svg" alt="close btn" className="w-100" />
                        </button>
                        <div className="backicons d-flex justify-content-between">
                            <button type="button" className="btn backbtn d-lg-block d-none" onClick={handleCloseButtonClick}>
                                <img src="/img/backbtn.svg" alt="Back button
" className="w-100" />
                            </button>
                            <button type="button" className="btn close d-lg-block d-none" onClick={handleCloseButtonClick}>
                                <img src="/img/closebtn.png" alt="A circular icon with a white center and a dark blue border, featuring a gray "X" in the middle.
" className="w-100" />
                            </button>
                        </div>
                    </div>

                    <div className="container">
                        <div className="row align-items-center">

                            <div className="col-md-12">
                                <Tabs
                                    activeKey={activeKey}
                                    onSelect={handleTabSelect}
                                    transition={false}
                                    id="centered-tab-example"
                                    className="d-flex justify-content-center mb-3"
                                >


                                    <Tab
                                        eventKey="home"
                                        title={
                                            <div className="tab-title-container">
                                                <img src={activeKey === 'home' ? '/img/1sticon-active.png' : '/img/1sticon.png'} alt="A rounded square icon with a white background featuring a lowercase letter "r" in dark blue.
" />
                                                <span className="tab-tooltip"><span>Home</span></span>
                                            </div>
                                        }
                                    >
                                        <CompOne />
                                    </Tab>

                                    <Tab
                                        eventKey="RentDirect"
                                        title={
                                            <div className="tab-title-container">
                                                <img
                                                    src={hoveredTab === 'RentDirect' || activeKey === 'RentDirect' ? '/img/2ndicon-active.png' : '/img/2ndicon.png'}
                                                    alt="A rounded square icon for Rentid's RentDirect product.  Features a dark blue gradient background. Centered within the icon are two overlapping triangles, one teal that is filled and semi-transparent, and another grey that is outlined.
.
"
                                                    onMouseEnter={() => setHoveredTab('RentDirect')}
                                                    onMouseLeave={() => setHoveredTab(null)}
                                                />
                                                <span className="tab-tooltip"><span>rent</span>direct</span>
                                            </div>
                                        }
                                    >
                                        <RentDirect />
                                    </Tab>

                                    <Tab
                                        eventKey="Rentid"
                                        title={
                                            <div className="tab-title-container">
                                                <img
                                                    src={hoveredTab === 'Rentid' || activeKey === 'Rentid' ? '/img/3rdicon-active.png' : '/img/3rdicon.png'}
                                                    alt="Icon for Rentid's RentID product.  It is grayscale with "ID" text in the center. The icon has a simplistic, minimalist design.
"
                                                    onMouseEnter={() => setHoveredTab('Rentid')}
                                                    onMouseLeave={() => setHoveredTab(null)}
                                                />
                                                <span className="tab-tooltip"><span>rent</span>ID</span>
                                            </div>
                                        }
                                    >
                                        <Rentid />
                                    </Tab>
                                    <Tab
                                        eventKey="rentshield"
                                        title={
                                            <div className="tab-title-container">
                                                <img
                                                    src={hoveredTab === 'rentshield' || activeKey === 'rentshield' ? '/img/4thicon-active.png' : '/img/4thicon.png'}
                                                    alt="Icon for Rentid's RentShield product. A minimalist illustration of a shield icon representing security or protection on a light gray background. The shield has a simple design, and the overall style is modern and clean.
"
                                                    onMouseEnter={() => setHoveredTab('rentshield')}
                                                    onMouseLeave={() => setHoveredTab(null)}
                                                />
                                                <span className="tab-tooltip"><span>rent</span>shield</span>
                                            </div>
                                        }
                                    >
                                        <RentShield />
                                    </Tab>
                                    <Tab
                                        eventKey="RentSuccess"
                                        title={
                                            <div className="tab-title-container">
                                                <img
                                                    src={hoveredTab === 'RentSuccess' || activeKey === 'RentSuccess' ? '/img/5thicon-active.png' : '/img/5thicon.png'}
                                                    alt="Icon for Rentid's RentSuccess product. The background is light gray with rounded corners.
"
                                                    onMouseEnter={() => setHoveredTab('RentSuccess')}
                                                    onMouseLeave={() => setHoveredTab(null)}
                                                />
                                                <span className="tab-tooltip"><span>rent</span>success</span>
                                            </div>
                                        }
                                    >
                                        <RentSuccess />
                                    </Tab>
                                    <Tab
                                        eventKey="RentAcademy"
                                        title={
                                            <div className="tab-title-container">
                                                <img
                                                    src={hoveredTab === 'RentAcademy' || activeKey === 'RentAcademy' ? '/img/6thicon-active.png' : '/img/6thicon.png'}
                                                    alt="Icon for Rentid's RentAcdademy product. A gray and white icon displaying a medal with a star in the center.
"
                                                    onMouseEnter={() => setHoveredTab('RentAcademy')}
                                                    onMouseLeave={() => setHoveredTab(null)}
                                                />
                                                <span className="tab-tooltip"><span>rent</span>academy</span>
                                            </div>
                                        }
                                    >
                                        <RentAcademy />
                                    </Tab>
                                </Tabs>
                            </div>
                        </div>
                    </div>
                </div> */}
                </div>
            </section>
            {/* <section className="slide-text-sec">
                <div className="container-fluid">
                <div className="col-md-12 main-heading-text text-center">
               
				  <h3><marquee width="100%" behavior="scroll" direction="left" scrollamount="7">
                <span className="infinite-txt">From on-board to on-rent in less than 60 minutes.   From on-board to on-rent in less than 60 minutes.     </span>
                <span className="infinite-txt">From on-board to on-rent in less than 60 minutes.   From on-board to on-rent in less than 60 minutes.     </span>
                <span className="infinite-txt">From on-board to on-rent in less than 60 minutes.   From on-board to on-rent in less than 60 minutes.     </span>
                <span className="infinite-txt">From on-board to on-rent in less than 60 minutes.   From on-board to on-rent in less than 60 minutes.     </span>
                <span className="infinite-txt">From on-board to on-rent in less than 60 minutes.   From on-board to on-rent in less than 60 minutes.     </span>
                <span className="infinite-txt">From on-board to on-rent in less than 60 minutes.   From on-board to on-rent in less than 60 minutes.     </span>
            <div></div></marquee></h3>

              </div>
                </div>
         
            </section> */}
      
        </>
    );
}

export default AnimationSection;
